import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanySupportChatRepository } from 'application/repositorySchemas/ICompanySupportChatRepository';
import { type ICompanySupportSendChatClient } from 'interfaceAdapter/gatewaySchemas/ICompanySupportSendChatClient';

@injectable()
export class CompanySupportChatRepository implements ICompanySupportChatRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanySupportSendChatClient')
        public readonly sendChatClient: ICompanySupportSendChatClient,
    ) {}

    public async send(message: string): Promise<void> {
        const { message: resMessage } = await this.sendChatClient.post({
            token: this.companyUserToken.get() || '',
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }
    }
}

